/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import {
  geTitleQuestions,
  getPageQuestions,
  getQuestionsWithIds,
} from "../../controllers/QuestionController";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  TextField,
  ButtonGroup,
  Button,
  MenuItem,
  Switch,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  Card,
  Tooltip,
  IconButton,
  Grid,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddAlarmIcon from "@mui/icons-material/AddAlarm";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";

import getText from "Translator";
import { useNavigate, useParams } from "react-router-dom";
import { getReport } from "controllers/ConditionController";
import { useMaterialUIController } from "context";
import AllQuestions from "views/pagequestions/components/AllQuestions";
import { displayErrorMessage } from "controllers/validation";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { displaySuccessMessage } from "controllers/validation";
import config from "configs/config";

const TextComponent = (props) => {
  const [controller] = useMaterialUIController();
  return (
    <Grid
      container
      xs={12}
      sm={12}
      md={12}
      spacing={1}
      style={{ marginTop: 15 }}
    >
      <Grid item xs={1} sm={1} md={1}>
        <Tooltip
          title="حذف"
          aria-label="delete"
          style={{ padding: 3, cursor: "pointer" }}
        >
          <HighlightOffOutlinedIcon
            color="secondary"
            onClick={() => {
              props.handleDeleteFilterClick(props.question.id);
            }}
          />
        </Tooltip>
      </Grid>
      <Grid item xs={3} sm={3} md={3}>
        <b style={{ width: 200, minWidth: 200 }}>{props.question.text}</b>
      </Grid>
      <Grid item xs={3} sm={3} md={3}>
        <Select
          labelId="demo-mutiple-name-label"
          id="demo-mutiple-name"
          variant="outlined"
          fullWidth
          onChange={async (event) => {
            let existQuestions = await localStorage.getItem("@reportQuestions");
            if (existQuestions) {
              existQuestions = JSON.parse(existQuestions);
              let questions = existQuestions.filter(
                (a) => a.id + "" == props.question.id + ""
              );
              if (questions.length > 0) {
                questions[0]["op"] = event.target.value;

                existQuestions = existQuestions.filter(
                  (a) => a.id + "" !== props.question.id + ""
                );
                existQuestions.push(questions[0]);
                localStorage.setItem(
                  "@reportQuestions",
                  JSON.stringify(existQuestions)
                );
              }
            }
          }}
        >
          <MenuItem value="eq">{getText("equal", controller.lang)}</MenuItem>
          <MenuItem value="ne">{getText("unequal", controller.lang)}</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={5} sm={5} md={5}>
        <TextField
          id={props.question.id}
          fullWidth
          onChange={async (event) => {
            let existQuestions = await localStorage.getItem("@reportQuestions");
            if (existQuestions) {
              existQuestions = JSON.parse(existQuestions);
              let questions = existQuestions.filter(
                (a) => a.id + "" == props.question.id + ""
              );
              if (questions.length > 0) {
                questions[0]["value"] = event.target.value;

                existQuestions = existQuestions.filter(
                  (a) => a.id + "" !== props.question.id + ""
                );
                existQuestions.push(questions[0]);
                localStorage.setItem(
                  "@reportQuestions",
                  JSON.stringify(existQuestions)
                );
              }
            }
          }}
          variant="outlined"
        />
        {/* {props.question.helpPage !== undefined && (
        <a href="#">
          <div style={{ width: "100%", textAlign: "right" }}>
            {props.question.helpText}
          </div>
        </a>
      )} */}
      </Grid>
    </Grid>
  );
};
const NumberComponent = (props) => {
  const [controller] = useMaterialUIController();
  return (
    <Grid
      container
      xs={12}
      sm={12}
      md={12}
      spacing={1}
      style={{ marginTop: 15 }}
    >
      <Grid item xs={1} sm={1} md={1}>
        <Tooltip
          title="delete"
          aria-label="delete"
          style={{ padding: 3, cursor: "pointer" }}
        >
          <HighlightOffOutlinedIcon
            color="secondary"
            onClick={() => {
              props.handleDeleteFilterClick(props.question.id);
            }}
          />
        </Tooltip>
      </Grid>
      <Grid item xs={3} sm={3} md={3}>
        <b style={{ width: 200, minWidth: 200 }}>{props.question.text}</b>
      </Grid>
      <Grid item xs={3} sm={3} md={3}>
        <Select
          labelId="demo-mutiple-name-label"
          id="demo-mutiple-name"
          variant="outlined"
          fullWidth
          onChange={async (event) => {
            let existQuestions = await localStorage.getItem("@reportQuestions");
            if (existQuestions) {
              existQuestions = JSON.parse(existQuestions);
              let questions = existQuestions.filter(
                (a) => a.id + "" == props.question.id + ""
              );
              if (questions.length > 0) {
                questions[0]["op"] = event.target.value;

                existQuestions = existQuestions.filter(
                  (a) => a.id + "" !== props.question.id + ""
                );
                existQuestions.push(questions[0]);
                localStorage.setItem(
                  "@reportQuestions",
                  JSON.stringify(existQuestions)
                );
              }
            }
          }}
        >
          <MenuItem value="gt">بزرگتر</MenuItem>
          <MenuItem value="gte">بزرگتر مساوی</MenuItem>
          <MenuItem value="lt">کوچکتر </MenuItem>
          <MenuItem value="lte">کوچکتر مساوی</MenuItem>
          <MenuItem value="eq">{getText("equal", controller.lang)}</MenuItem>
          <MenuItem value="ne">{getText("unequal", controller.lang)}</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={5} sm={5} md={5}>
        <TextField
          fullWidth
          id={props.question.id}
          onChange={async (event) => {
            let existQuestions = await localStorage.getItem("@reportQuestions");
            if (existQuestions) {
              existQuestions = JSON.parse(existQuestions);
              let questions = existQuestions.filter(
                (a) => a.id + "" == props.question.id + ""
              );
              if (questions.length > 0) {
                questions[0]["value"] = event.target.value;

                existQuestions = existQuestions.filter(
                  (a) => a.id + "" !== props.question.id + ""
                );
                existQuestions.push(questions[0]);
                localStorage.setItem(
                  "@reportQuestions",
                  JSON.stringify(existQuestions)
                );
              }
            }
          }}
          variant="outlined"
          type="number"
        />
        {/* {props.question.helpPage !== undefined && (
        <a href="#">
          <div style={{ width: "100%", textAlign: "right" }}>
            {props.question.helpText}
          </div>
        </a>
      )} */}
      </Grid>
    </Grid>
  );
};
const SelectComponent = (props) => {
  const [controller] = useMaterialUIController();
  useEffect(() => {
    console.log("propsprops", props);
  }, []);
  return (
    <Grid
      container
      xs={12}
      sm={12}
      md={12}
      spacing={1}
      style={{ marginTop: 15 }}
    >
      <Grid item xs={1} sm={1} md={1}>
        <Tooltip
          title="delete"
          aria-label="delete"
          style={{ padding: 3, cursor: "pointer" }}
        >
          <HighlightOffOutlinedIcon
            color="secondary"
            fontSize="18"
            onClick={() => {
              props.handleDeleteFilterClick(props.question.id);
            }}
          />
        </Tooltip>
      </Grid>
      <Grid item xs={3} sm={3} md={3}>
        <b style={{ width: 200, minWidth: 200 }}>{props.question.text}</b>
      </Grid>
      <Grid item xs={3} sm={3} md={3}>
        <Select
          labelId="demo-mutiple-name-label"
          id="demo-mutiple-name"
          variant="outlined"
          fullWidth
          onChange={async (event) => {
            let existQuestions = await localStorage.getItem("@reportQuestions");
            if (existQuestions) {
              existQuestions = JSON.parse(existQuestions);
              let questions = existQuestions.filter(
                (a) => a.id + "" == props.question.id + ""
              );
              if (questions.length > 0) {
                questions[0]["op"] = event.target.value;

                existQuestions = existQuestions.filter(
                  (a) => a.id + "" !== props.question.id + ""
                );
                existQuestions.push(questions[0]);
                localStorage.setItem(
                  "@reportQuestions",
                  JSON.stringify(existQuestions)
                );
              }
            }
          }}
        >
          <MenuItem value="eq">{getText("equal", controller.lang)}</MenuItem>
          <MenuItem value="ne">{getText("unequal", controller.lang)}</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={5} sm={5} md={5}>
        <Select
          labelId="demo-mutiple-name-label"
          id="demo-mutiple-name"
          variant="outlined"
          fullWidth
          onChange={async (event) => {
            let existQuestions = await localStorage.getItem("@reportQuestions");
            if (existQuestions) {
              existQuestions = JSON.parse(existQuestions);
              let questions = existQuestions.filter(
                (a) => a.id + "" == props.question.id + ""
              );
              if (questions.length > 0) {
                questions[0]["value"] = event.target.value;

                existQuestions = existQuestions.filter(
                  (a) => a.id + "" !== props.question.id + ""
                );
                existQuestions.push(questions[0]);
                localStorage.setItem(
                  "@reportQuestions",
                  JSON.stringify(existQuestions)
                );
              }
            }
          }}
        >
          {props.question.answers &&
            props.question.answers.map((ans) => (
              <MenuItem value={ans.value}>{ans.text}</MenuItem>
            ))}
        </Select>
      </Grid>
    </Grid>
  );
};

const CalcComponent = (props) => {
  const [controller] = useMaterialUIController();
  return (
    <Grid container xs={12} sm={12} md={12} style={{ marginTop: 15 }}>
      <Grid item xs={1} sm={1} md={1}>
        <b>{props.question.text}</b>
        <TextField
          id={props.question.questionId}
          fullWidth={true}
          value={props.question.userAnswer}
          placeholder={props.question.tooltip}
          onChange={(event) => {}}
          variant="outlined"
          multiline={true}
          disabled={true}
        />
        {/* {props.question.helpPage !== undefined && (
        <a href="#">
          <div style={{ width: "100%", textAlign: "right" }}>
            {props.question.helpText}
          </div>
        </a>
      )} */}
      </Grid>
    </Grid>
  );
};

const Report = (props) => {
  const [controller] = useMaterialUIController();
  const [questionList, setQuestionList] = useState([]);
  const [questions, setQuestions] = useState([]);

  const [listMode, setListMode] = useState("list");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("questions");
  const params = useParams();
  const navigate = useNavigate();
  const displayQuestionList = async () => {
    let existQuestions = await localStorage.getItem("@reportQuestionsList");
    if (existQuestions) {
      let questions = JSON.parse(existQuestions);
      questions = questions.filter((a) => a.title == params.title);
      setQuestionList(questions);
    }
  };
  const handleAddQuestionToReport = async (id, text) => {
    try {
      let existQuestions = await localStorage.getItem("@reportQuestionsList");
      let questions = [];
      if (!existQuestions) {
        questions.push({ title: props.title, id, text });
        localStorage.setItem("@reportQuestionsList", JSON.stringify(questions));
        displayQuestionList();
      } else {
        questions = JSON.parse(existQuestions);
        let existId = questions.filter(
          (a) => a.id + "" == id + "" && a.title == props.title
        );
        if (existId.length == 0) {
          questions.push({ title: props.title, id, text });
          localStorage.setItem(
            "@reportQuestionsList",
            JSON.stringify(questions)
          );
          displayQuestionList();
        } else {
          Swal.fire({
            text: "این فیلد قبلا در لیست قرار گرفته است",

            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
    //
  };

  const handleAddQuestionToCoditionReport = async (id, text) => {
    try {
      let existQuestions = await localStorage.getItem("@reportQuestions");
      let questions = [];
      if (!existQuestions) {
        questions.push({ title: props.title, id, text });
        localStorage.setItem("@reportQuestions", JSON.stringify(questions));
        getQuestions();
      } else {
        questions = JSON.parse(existQuestions);
        let existId = questions.filter(
          (a) => a.id + "" == id + "" && a.title == props.title
        );
        if (existId.length == 0) {
          questions.push({ title: props.title, id, text });
          localStorage.setItem("@reportQuestions", JSON.stringify(questions));
          getQuestions();
        } else {
          Swal.fire({
            text: "این فیلد قبلا در لیست قرار گرفته است",

            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
    //
  };
  useEffect(() => {
    //getQuestions();

    displayQuestionList();
    getQuestions();
  }, []);
  const handleClose = () => {
    setOpen(false);
  };

  const getQuestions = async () => {
    let existQuestions = await localStorage.getItem("@reportQuestions");
    if (existQuestions) {
      setLoading(true);

      let questions = JSON.parse(existQuestions);
      questions = questions.filter((a) => a.title == params.title);
      let questionIds = [];
      questions.map((item) => {
        questionIds.push(item.id);
      });

      let datas = await getQuestionsWithIds(
        controller.lang,
        { questions: questionIds },
        controller.token
      );
      if (!datas.success) {
        if (datas.errorCode === 101) {
          Swal.fire({
            text: "Warning",
            position: "top-end",
            icon: "warning",
            showConfirmButton: false,
            timer: 1500,
          });
          navigate("/");
        }
      } else {
        setQuestions(datas.data);
      }
    }
    setLoading(false);
  };

  const handleDeleteQuestionClick = async (id) => {
    let existQuestions = await localStorage.getItem("@reportQuestionsList");
    if (existQuestions) {
      let questions = JSON.parse(existQuestions);
      questions = questions.filter((a) => a.id !== id);
      localStorage.setItem("@reportQuestionsList", JSON.stringify(questions));
      setQuestionList(questions);
    }
  };

  const handleDeleteFilterClick = async (id) => {
    try {
      let existFilters = await localStorage.getItem("@reportQuestions");
      if (existFilters) {
        let reportquestions = JSON.parse(existFilters);
        reportquestions = reportquestions.filter((a) => a.id + "" !== id + "");

        localStorage.setItem(
          "@reportQuestions",
          JSON.stringify(reportquestions)
        );
        console.log(id, reportquestions.length, reportquestions);
        setQuestions(reportquestions);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const getPageQuestionsDatas = async () => {
    try {
      setLoading(true);
      let newData = {
        lang: controller.lang,
        page: params.page,
      };

      let data = await getPageQuestions(
        controller.lang,
        newData,
        controller.token
      );
      setLoading(false);
      if (data.success) {
        setQuestionList(data.data);
      } else {
        displayErrorMessage(controller.lang, data.message, data.code);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  const AllQuestionHandler = (mode) => {
    setMode(mode);
    setOpen(true);
  };

  const getReportFile = async () => {
    let filter = await localStorage.getItem("@reportQuestions");
    if (filter) {
      filter = JSON.parse(filter);
    } else {
      filter = [];
    }
    console.log("paramsparams", params);
    let newData = {
      title: params.title,
      capsule: params.capsule,
      questions: questionList,
      filter,
    };
    let res = await getReport(controller.lang, newData, controller.token);
    if (!res.success) {
      displaySuccessMessage(controller.lang, res.message);
      return;
    }
    console.log(config.server + res.data);
    saveAs(config.server + res.data, res.fileName);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar
        title={getText("report", controller.lang)}
        showserch={false}
      />
      <MDBox pb={3}>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Grid container style={{ paddingTop: 16 }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{
                  fontSize: 22,
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                فیلدهای گزارش
                <Tooltip
                  title="افزودن  فیلدهای گزارش"
                  aria-label="addquestion"
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    cursor: "pointer",
                    fontSize: 22,
                  }}
                >
                  <AddCircleOutlineIcon
                    style={{
                      cursor: "pointer",
                      float: "left",
                      color: "#039dfc",
                      fontSize: 24,
                      marginTop: 5,
                    }}
                    onClick={() => AllQuestionHandler("questions")}
                  />
                </Tooltip>
              </Grid>
            </Grid>

            <Card>
              <LoadingOverlay
                active={loading}
                spinner
                text={getText("loading", controller.lang)}
              >
                <Grid container>
                  {questionList.map((item, index) => (
                    <div
                      style={{
                        flexDirection: "row",
                        minWidth: 100,
                        borderRadius: 10,
                        backgroundColor: "#f2f2f2",
                        marginLeft: 8,
                        marginBottom: 8,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Tooltip
                        title={getText("delete", controller.lang)}
                        aria-label="delete"
                        style={{ padding: 3, cursor: "pointer" }}
                      >
                        <HighlightOffOutlinedIcon
                          color="secondary"
                          onClick={() => {
                            handleDeleteQuestionClick(item.id);
                          }}
                        />
                      </Tooltip>
                      {item.text}
                    </div>
                  ))}
                </Grid>
              </LoadingOverlay>
            </Card>
          </Card>
          <Card style={{ marginTop: 20 }}>
            <Grid container style={{ paddingTop: 16 }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{
                  fontSize: 22,
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                شروط گزارش
                <Tooltip
                  title={"افزودن شروط گزارش"}
                  aria-label="addquestion"
                  style={{
                    paddingRight: 5,
                    paddingLeft: 5,
                    cursor: "pointer",
                    fontSize: 22,
                  }}
                >
                  <AddCircleOutlineIcon
                    style={{
                      cursor: "pointer",
                      float: "left",
                      color: "#039dfc",
                      fontSize: 24,
                      marginTop: 5,
                    }}
                    onClick={() => AllQuestionHandler("filter")}
                  />
                </Tooltip>
              </Grid>
            </Grid>

            <Card>
              <LoadingOverlay
                active={loading}
                spinner
                text={getText("loading", controller.lang)}
              >
                <Grid container>
                  {questions.map((item, index) => {
                    switch (item.questionType) {
                      case "TEXT":
                      case "CALC": {
                        return (
                          <TextComponent
                            question={item}
                            itemsCount={questionList.length}
                            index={index}
                            key={item.id}
                            formType={props.formType}
                            page={params.page}
                            form={props.form}
                            handleDeleteFilterClick={handleDeleteFilterClick}
                          />
                        );
                      }

                      // case "DATE": {
                      //   return (
                      //     <CalcComponent
                      //       question={item}
                      //       itemsCount={questionList.length}
                      //       index={index}
                      //       key={item.id}
                      //       formType={props.formType}
                      //       page={params.page}
                      //       form={props.form}
                      //     />
                      //   );
                      // }
                      case "INT":
                      case "RANGE": {
                        return (
                          <NumberComponent
                            question={item}
                            itemsCount={questionList.length}
                            index={index}
                            key={item.id}
                            formType={props.formType}
                            page={params.page}
                            form={props.form}
                            handleDeleteFilterClick={handleDeleteFilterClick}
                          />
                        );
                      }

                      case "SELECT":
                      case "DBS":
                      case "FLAT":
                      case "CHECKED":
                      case "MRD":
                      case "DB": {
                        return (
                          <SelectComponent
                            question={item}
                            itemsCount={questionList.length}
                            index={index}
                            key={item.id}
                            formType={props.formType}
                            page={params.page}
                            form={props.form}
                            handleDeleteFilterClick={handleDeleteFilterClick}
                          />
                        );
                      }
                    }
                  })}
                </Grid>
                <Grid container style={{ float: "left" }}>
                  <Button
                    fullWidth
                    style={{ marginTop: 35 }}
                    color="primary"
                    onClick={() => {
                      getReportFile();
                    }}
                  >
                    {getText("getreportfile", controller.lang)}
                  </Button>
                </Grid>
              </LoadingOverlay>
            </Card>
          </Card>
        </Grid>

        <Dialog
          open={open}
          //onClose={handleClose}
          aria-labelledby="form-dialog-title"
          fullScreen={mode === "copy"}
        >
          <DialogTitle id="form-dialog-title">
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            {getText("questions", controller.lang)}
          </DialogTitle>
          <DialogContent>
            {mode === "questions" && (
              <AllQuestions
                capsule={params.capsule}
                page={params.page}
                getPageQuestionsDatas={getPageQuestionsDatas}
                handleAddQuestionToReport={handleAddQuestionToReport}
              />
            )}
            {mode === "filter" && (
              <AllQuestions
                capsule={params.capsule}
                page={params.page}
                getPageQuestionsDatas={getPageQuestionsDatas}
                handleAddQuestionToCoditionReport={
                  handleAddQuestionToCoditionReport
                }
              />
            )}
          </DialogContent>
        </Dialog>
      </MDBox>
    </DashboardLayout>
  );
};

export default Report;
